module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "copyrightPage",
    attrs: {
      "id": "copyrightPage"
    }
  }, [_c('p', {
    staticClass: "copyrightText"
  }, [_vm._v("© 2006 by Terrence J. Winschel")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText1"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted, in any form or by any means, electronic, mechanical, photocopying, recording, or otherwise, without the prior written permission of the publisher. Printed in the United States of America.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText3"
  }, [_vm._v("Cataloging-in-Publication Data is available from the Library of Congress.")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText3"
  }, [_vm._v("ISBN 1-932714-21-9")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_vm._v("eISBN 9781611210187")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText3"
  }, [_vm._v("05 04 03 02 01   5 4 3 2 1")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_vm._v("First edition, first printing")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText2"
  }, [_vm._v("Published by")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_vm._v("Savas Beatie LLC")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_vm._v("521 Fifth Avenue, Suite 3400")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_vm._v("New York, NY 10175")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_vm._v("Phone: 610-853-9131")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText3"
  }, [_vm._v("Editorial Offices:")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText3"
  }, [_vm._v("Savas Beatie LLC")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_vm._v("P.O. Box 4527")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_vm._v("El Dorado Hills, CA 95762")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_vm._v("Phone: 916-941-6896")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText"
  }, [_vm._v("(E-mail) editorial@savasbeatie.com")]), _vm._v(" "), _c('p', {
    staticClass: "copyrightText4"
  }, [_vm._v("Savas Beatie titles are available at special discounts for bulk purchases in the United States by corporations, institutions, and other organizations. For more details, please contact Special Sales, P.O. Box 4527, El Dorado Hills, CA 95762, or you may e-mail us at sales@savasbeatie.com, or visit our website at "), _c('a', {
    attrs: {
      "href": "http://www.savasbeatie.com",
      "target": "_blank"
    }
  }, [_vm._v("www.savasbeatie.com")]), _vm._v(" for additional information.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-647aba50","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TriumphandDefeat_copyrightPage.vue
// module id = 63
// module chunks = 0